import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled(motion.div)`
  ${({ theme }) => css`
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    transform-origin: top;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing(10)};
    gap: ${theme.spacing(4)};
    background-color: white;
    will-change: opacity;
    transform: translateZ(0); /* Force hardware acceleration */
  `}
`

export const Text = styled(motion.div)`
  ${({ theme }) => css`
    font-size: ${theme.fontSize(4)};
    color: ${theme.palette.grey[600]};
    text-align: center;
    will-change: opacity;
    transform: translateZ(0); /* Force hardware acceleration */
  `}
`
